import { useCallback, useEffect, useMemo, useState } from 'react'
import {
   Breadcrumb,
   Button,
   Card,
   Col,
   DatePicker,
   Form,
   Input,
   InputNumber,
   notification,
   Radio,
   Row,
   Typography
} from 'antd'
import { EditOutlined, HomeOutlined, LeftCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { useHistory, useParams } from 'react-router-dom'
import { useStore } from 'src/hooks'
import { debounce } from 'lodash'
import FloatLabel from 'src/common/components/float-label'
import { useTranslation } from 'react-i18next'
import i18n from 'src/helpers/i18n'
import { createValidationRules } from 'src/helpers/validateRule'
import { observer } from 'mobx-react-lite'
import { useLoading } from 'src/common/components/LoadingContainer'
import { DATE_TIME_FORMAT_CLIENT, TYPE_PROMOTION } from 'src/helpers/constants'
import moment from 'moment'

const { Title } = Typography

const PromotionCreateScreen = observer(() => {
   const history = useHistory()
   const [form] = Form.useForm()
   const UserStore = useStore('UserStore')
   const { t } = useTranslation()
   const { id } = useParams<{ id: string }>()
   // const ckeditorRef = useRef<any>()
   const { showLoading, hideLoading } = useLoading()
   const [detail, setDetail] = useState<any>(null)

   const [promotionType, setPromotionType] = useState<string>(TYPE_PROMOTION[0].value)

   const readOnly = useMemo(() => {
      if (history.location.pathname.includes('detail')) {
         return true
      } else {
         return false
      }
   }, [history.location])

   // Re-create rules when language changes
   const rule = useMemo(() => createValidationRules(), [i18n.language])

   useEffect(() => {
      if (id && id !== 'create') {
         handleGetDetail()
      }
   }, [id])

   // Fetch detail thông tin kênh bán hàng
   const handleGetDetail = useCallback(async () => {
      if (!id) {
         return
      }
      try {
         showLoading()

         if (UserStore.promotionSelected) {
            setDetail(UserStore.promotionSelected)
            setPromotionType(UserStore.promotionSelected?.type)
            form.setFieldsValue({
               ...UserStore.promotionSelected,
               startDate: UserStore.promotionSelected?.startDate ? moment(UserStore.promotionSelected.startDate) : null,
               endDate: UserStore.promotionSelected?.endDate ? moment(UserStore.promotionSelected.endDate) : null,
               isActive: UserStore.promotionSelected?.isActive ?? false
            })

            // setTimeout(() => {
            //    //@ts-ignore
            //    ckeditorRef.current?.setData?.(fetchedDetail?.des)
            // }, 500)
         }
      } finally {
         hideLoading()
      }
   }, [])

   const onFinish = async (values: any) => {
      // Kiểm tra từng field required
      // for (const field of requiredFields) {
      //    const fieldValue = values[field.key]

      //    if (!fieldValue || (typeof fieldValue === 'string' && fieldValue.trim() === '')) {
      //       setActiveTab(field.tab)
      //       return // Dừng lại ngay khi phát hiện lỗi
      //    }
      // }
      console.log('values', values)
      const body = {
         ...values
         // startDate: moment(values.startDate).format('DD/MM/YYYY hh:mm'), endDate: moment(values.endDate).format('DD/MM/YYYY hh:mm')
      }
      console.log(
         'body',
         body,
         `startDate: moment(values.startDate).format('DD/MM/YYYY hh:mm')`,
         moment(values.startDate).format('DD/MM/YYYY hh:mm')
      )

      // Submit the sanitized data
      const data = id ? await UserStore.updatePromotion(body, id) : await UserStore.createPromotion(body)
      console.log('data', data, ' id', id)

      if (data) {
         if (id) {
            notification.open({
               message: t('notification'),
               description: t('update_successfully'),
               type: 'success',
               placement: 'topRight'
            })
         } else {
            notification.open({
               message: t('notification'),
               description: t('create_successfully'),
               type: 'success',
               placement: 'topRight'
            })
         }
         history.goBack()
      }
   }

   const renderContent = () => {
      return (
         <div style={{ pointerEvents: readOnly ? 'none' : 'all' }}>
            <Card style={{ width: '100%', marginTop: '20px' }}>
               <Row
                  className="gx-flex-row"
                  gutter={12}
                  style={{
                     flex: 1,
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     paddingLeft: 0,
                     paddingRight: 0
                  }}
               >
                  <Col xs={12} md={12}>
                     <FloatLabel label={'Code'} required>
                        <Form.Item name="code" rules={[rule.requiredEnter, rule.maxRuleCharacter10]}>
                           <Input placeholder={t('enter')} maxLength={10} readOnly={readOnly} />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
                  <Col xs={12} md={12}>
                     <FloatLabel label={'Tiêu đề'} required>
                        <Form.Item name="name" rules={[rule.requiredEnter]}>
                           <Input placeholder={t('enter')} maxLength={500} readOnly={readOnly} />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
               </Row>
               <Row
                  className="gx-flex-row"
                  gutter={12}
                  style={{
                     flex: 1,
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     paddingLeft: 0,
                     paddingRight: 0
                  }}
               >
                  <Col style={{}} xs={12} md={12}>
                     <FloatLabel label={'Ngày bắt đầu'} required>
                        <Form.Item name="startDate" rules={[rule.requiredSelect]}>
                           <DatePicker
                              placeholder={t('select')}
                              showTime
                              format={DATE_TIME_FORMAT_CLIENT}
                              allowClear
                              disabledDate={(d) => !d || d.isBefore(moment().endOf('day'))}
                              style={{ width: '100%' }}
                           />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
                  <Col style={{}} xs={12} md={12}>
                     <FloatLabel label={'Ngày kết thúc'} required>
                        <Form.Item name="endDate" rules={[rule.requiredSelect]}>
                           <DatePicker
                              placeholder={t('select')}
                              format={DATE_TIME_FORMAT_CLIENT}
                              allowClear
                              showTime
                              disabledDate={(d) => !d || d.isBefore(moment().endOf('day'))}
                              style={{ width: '100%' }}
                           />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
               </Row>
               <Row
                  className="gx-flex-row"
                  gutter={12}
                  style={{
                     flex: 1,
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     paddingLeft: 0,
                     paddingRight: 0
                  }}
               >
                  <Col xs={12} md={12}>
                     <Form.Item name="type" initialValue={TYPE_PROMOTION[0].value}>
                        <Radio.Group
                           options={TYPE_PROMOTION}
                           buttonStyle="solid"
                           optionType="button"
                           onChange={(e) => setPromotionType(e.target.value)}
                        />
                     </Form.Item>
                  </Col>
               </Row>
               {/* Render các field theo loại khuyến mãi */}
               {/* 'Giảm theo %'  */}
               {promotionType === TYPE_PROMOTION[0].value ? (
                  <Row gutter={12} className="gx-flex-row">
                     <Col xs={12} md={12}>
                        <FloatLabel label={'Phần trăm'} required>
                           <Form.Item name="value" rules={[rule.requiredEnter]}>
                              <InputNumber
                                 min={1}
                                 max={100}
                                 formatter={(value) => `${value}%`}
                                 parser={(value) => value!.replace('%', '')}
                              />
                           </Form.Item>
                        </FloatLabel>
                     </Col>
                     <Col xs={12} md={12}>
                        <FloatLabel label={'Số tiền tối đa được giảm'} required>
                           <Form.Item name="maxDiscountAmount" rules={[rule.requiredEnter]}>
                              <InputNumber
                                 min={1}
                                 formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                 parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                              />
                           </Form.Item>
                        </FloatLabel>
                     </Col>
                  </Row>
               ) : (
                  <Row gutter={12} className="gx-flex-row">
                     <Col xs={24} md={24}>
                        <FloatLabel label={'Số tiền giảm'} required>
                           <Form.Item name="value" rules={[rule.requiredEnter]}>
                              <InputNumber
                                 min={1}
                                 formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                 parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                              />
                           </Form.Item>
                        </FloatLabel>
                     </Col>
                  </Row>
               )}
               <Row gutter={12} className="gx-flex-row">
                  {/* <Col xs={12} md={12}>
                     <FloatLabel label={'Số lượng sử dụng tối đa'} required>
                        <Form.Item name="value" rules={[rule.requiredEnter]}>
                           <InputNumber 
                              min={1}
                              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                           />
                        </Form.Item>
                     </FloatLabel>
                  </Col> */}
                  <Col xs={24} md={24}>
                     <FloatLabel label={'Tiền tối thiểu nhận được'} required>
                        <Form.Item name="minOrderAmount" rules={[rule.requiredEnter]}>
                           <InputNumber
                              min={1}
                              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                           />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
               </Row>
               <Row
                  className="gx-flex-row"
                  gutter={12}
                  style={{
                     flex: 1,
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     paddingLeft: 0,
                     paddingRight: 0
                  }}
               >
                  <Col style={{}} xs={24} md={24}>
                     <FloatLabel label={'Mô tả'}>
                        <Form.Item name="description">
                           <Input.TextArea rows={3} placeholder={t('enter')} maxLength={1000} readOnly={readOnly} />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
               </Row>
               <Row gutter={24}>
                  <Col xs={24}>
                     <FloatLabel label={'Trạng thái hoạt động'} required>
                        <Form.Item name="isActive" initialValue={UserStore.promotionSelected?.isActive ?? false}>
                           <Radio.Group
                              disabled={readOnly}
                              defaultValue={UserStore.promotionSelected?.isActive ?? false}
                           >
                              <Radio value={true}>Đang hoạt động</Radio>
                              <Radio value={false}>Ngừng hoạt động</Radio>
                           </Radio.Group>
                        </Form.Item>
                     </FloatLabel>
                  </Col>
               </Row>
            </Card>
         </div>
      )
   }

   return (
      <div>
         <Row style={{ padding: '0 20px' }} className="gx-justify-content-between gx-align-items-center">
            <Col>
               <Title level={4}>{'Khuyến mãi'}</Title>
               <Breadcrumb>
                  <Breadcrumb.Item href="/">
                     <HomeOutlined className="gx-link" />
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{'Admin'}</Breadcrumb.Item>
                  <Breadcrumb.Item onClick={() => history.goBack()} className="gx-link">
                     {'Khuyến mãi'}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{id ? (readOnly ? t('details') : t('edit')) : t('add_new')}</Breadcrumb.Item>
                  {id && <Breadcrumb.Item>{id}</Breadcrumb.Item>}
               </Breadcrumb>
            </Col>
         </Row>
         <Form
            form={form}
            name="basic"
            initialValues={{}}
            autoComplete="off"
            layout="vertical"
            onFinish={debounce(onFinish, 600)}
            onFinishFailed={(errorInfo) => {
               console.log('Validation Failed:', errorInfo)
            }}
         >
            {renderContent()}
            <Form.Item style={{ width: '100%', textAlign: 'center' }}>
               {readOnly ? (
                  <Button
                     icon={<LeftCircleOutlined />}
                     type="dashed"
                     style={{ color: '#ED5C19' }}
                     onClick={() => history.goBack()}
                  >
                     {t('txt_back')}
                  </Button>
               ) : (
                  <>
                     <Button
                        icon={<LeftCircleOutlined />}
                        type="dashed"
                        style={{ color: '#ED5C19' }}
                        onClick={() => history.goBack()}
                        className="gx-mr-2"
                     >
                        {t('txt_back')}
                     </Button>
                     <Button
                        icon={id ? <EditOutlined /> : <PlusCircleOutlined />}
                        type="primary"
                        htmlType="submit"
                        className="gx-mr-2"
                     >
                        {id ? t('update') : t('create')}
                     </Button>
                  </>
               )}
            </Form.Item>
         </Form>
      </div>
   )
})

export default PromotionCreateScreen
